import html2canvas from 'html2canvas-pro'
import { toPng } from '@intuiface/html-to-image'

const imageLoadTimeout = 5000

const isSafari = () => /Safari/i.test(navigator.userAgent) && !/Chrome|Chromium|Android/i.test(navigator.userAgent)

const captureNode = async node => {
  if (!isSafari()) return toPng(node, { cacheBust: true })

  const canvas = await html2canvas(node, {
    backgroundColor: null,
    logging: false,
    scale: 1,
    useCORS: true,
    allowTaint: false,
    foreignObjectRendering: false,
  })

  return canvas.toDataURL('image/png')
}

const waitForImage = img => {
  if (!img) return Promise.resolve()

  return new Promise((resolve, reject) => {
    let settled = false

    const finish = callback => value => {
      if (settled) return
      settled = true
      clearTimeout(timeoutId)
      img.removeEventListener("load", onLoad)
      img.removeEventListener("error", onError)
      callback(value)
    }

    const onLoad = finish(resolve)
    const onError = finish(reject)
    const timeoutId = setTimeout(() => {
      onError(new Error(`Image failed to load for preview capture: ${img.currentSrc || img.src}`))
    }, imageLoadTimeout)

    img.addEventListener("load", onLoad, { once: true })
    img.addEventListener("error", onError, { once: true })

    if (img.complete) {
      if (img.naturalWidth > 0) onLoad()
      else onError(new Error(`Image failed to load for preview capture: ${img.currentSrc || img.src}`))
    }
  })
}

const waitForImagesInNode = async node => {
  const images = Array.from(node.querySelectorAll("img"))
  await Promise.all(images.map(waitForImage))
}

export {
  captureNode,
  waitForImagesInNode,
}
